
import Multiselect from 'vue-multiselect'
import {  Component, Prop } from 'vue-property-decorator'
import { DEFAULT_MAX_UPLOAD_SIZE_MB, ALLOWED_EXTENSIONS } from '../helpers/constants'
import Mixin from '../helpers/mixin'

@Component({
  template: `
    <div class="form-field" :style="textAreaRowStyle" :class="[getCssClass(field.type), {error}]">
        <label v-if="field.type !== 'Checkbox'" :for="field.labelForm">{{ field.labelForm }} {{ field.requiredForm ? '*' : '' }}</label>
        <textarea v-if="field.type === 'TextArea'" :value='value' :id="field.labelForm" :placeholder="field.placeholderForm" @input='$emit("input", $event.target.value)'></textarea>
        <multiselect ref="multiselect"  v-else-if="field.type === 'Dropdown'" :options="field.dropdownFields" :value='value' :placeholder="field.placeholderForm" @input='$emit("input", $event)'>
          <template slot="singleLabel" slot-scope="{ option }">{{ option }}</strong>
          </template>
        </multiselect>
        <template v-else-if="field.type === 'File'">
          <input ref="fileInput" type="file" @change='$emit("input", $event.target.files[0])' :accept="this.allowedExtensions" />
          <button class="select-file" @click='triggerFileUpload'>
              <span class="file-name ellipsis" v-if="value">
                {{ value.name }}<i class="icons8-delete" @click.stop='$emit("input", null)'></i>
              </span>
              <span class="placeholder" v-else>
              {{ field.placeholderForm }}<i class="icons8-add-document"></i>
              </span>
            </button>
              <transition-expand>
                  <div class="error-message" v-if="showExtensionError">{{ 'formErrorWrongFileExtension' | t }}</div>
              </transition-expand>
              <transition-expand>
                  <div class="error-message" v-if="showMaxFileSizeError">{{ 'formErrorFileSizeTooBig' | t }} {{ maxFileSizeInMb }} MB</div>
              </transition-expand>
        </template>
        <input v-else :id="field.labelForm" :type="field.type" :value='value' :placeholder="field.placeholderForm" @input='$emit("input", $event.target.value)' />
    </div>
`
})


export default class GenericFormField extends Mixin {
  @Prop() field: any
  @Prop() value: any
  @Prop() error: boolean
  @Prop({default: 0}) index: number
  @Prop({default: 0}) numberOfFields: number

  allowedExtensions = ALLOWED_EXTENSIONS
  maxFileSizeInMb = DEFAULT_MAX_UPLOAD_SIZE_MB

  get rowNumber(): number {
    return Math.ceil(((this.index + 1) / 2 ))
  }

  get textAreaRowStyle(): object {
    if(this.field.type !== 'TextArea') return {}
    const isEvenNumber = (this.index + 1) % 2 === 0
    if(isEvenNumber && this.index + 1 === this.numberOfFields) return {}
    return {'grid-row': `${this.rowNumber} / ${this.rowNumber + 2}`, "grid-column": isEvenNumber ? 2 : 1 }
  }

  get showExtensionError(): boolean {
    return this.field.type === 'File' && !!this.value &&
      !!this.allowedExtensions &&
      !this.allowedExtensions.includes(`.${this.value.name.toLowerCase().split('.').pop()}`)
  }

  get showMaxFileSizeError(): boolean {
    return this.field.type === 'File' && !!this.value &&
      this.value.size / 1024 / 1024 > this.maxFileSizeInMb
  }

  getCssClass(type: string): string {
    return `form-field--${type.toLowerCase()}` + (type.toLowerCase() === 'checkbox'? ' generic--checkbox' : '')
  }

  triggerFileUpload(): void {
    (this.$refs.fileInput as HTMLInputElement).click()
  }

}
